export const GEMINI_MODEL = "gemini-2.5-pro";